import React from 'react';
import { FormGroup, Col, Row, ListGroup, ListGroupItem, Container } from 'reactstrap';
import Accordion from 'devextreme-react/accordion';
import { AEAField, AEATitle } from '@components/';
import { IProaTableData } from '@models/*';
import { ProaSummaryPresenter } from '@presenters/screens/proa-summary.presenter';
import style from './detail-data-implement-proa.module.scss';

export interface IDetailDataImplementProaProps {
    presenter: ProaSummaryPresenter
};


const DetailDataImplementProa = (props: IDetailDataImplementProaProps) => {

    const titleRender = (data:any) => {        
        return (
            <AEATitle 
                id={"implementers_list_0"} 
                text={data.title}
                placement={"auto"}
                tooltip={data.title}
            ></AEATitle>
        );
    }
    const itemRender = (data:any) => {
        return (
            <Row xs={1} md={3} className={style.accordionContent}>
                {props.presenter.getLocalPartners.adts?.map((item: IProaTableData, i: number) =>
                    <li key={i.toString()}>{item.OCTAVIASLEP?.Title}</li>)
                }
            </Row>
        )
    }

    return (
        <Container fluid={true}>
            <Row xs={1} md={2}>
                <Col>
                    <FormGroup>
                        <AEAField {...props.presenter.aeaParticipatesInEjecutionField}></AEAField>
                    </FormGroup>
                </Col>
            </Row>
            <Row xs={1} md={1}>
                <Col >
                    <FormGroup>
                        <AEAField {...props.presenter.aeaRolField}></AEAField>
                    </FormGroup>
                </Col>                
            </Row>
            <Row xs={1} md={1}>
                <Col >
                    <FormGroup>
                        <AEAField {...props.presenter.implementersRolField}></AEAField>
                    </FormGroup>
                </Col>                
            </Row>
            <Row className={style.accordionRow}>
            {props.presenter.getLocalPartners ?
                <Accordion
                    dataSource={[{title:props.presenter.currentLabels.get('ProaFormSociosLocales')}]}
                    collapsible={true}
                    multiple={false}
                    animationDuration={300}                                        
                    itemTitleRender={titleRender}
                    itemRender={itemRender}
                >
                </Accordion>: null
                }
            </Row>            
            <Row xs={1} md={1}>
                <Col >
                    <FormGroup>
                        <AEAField {...props.presenter.getOtherImplementers}></AEAField>
                    </FormGroup>
                </Col>                
            </Row>
            <Row xs={1} md={1}>
                <Col >
                    <FormGroup>
                        <AEAField {...props.presenter.getOtherImplementersRol}></AEAField>
                    </FormGroup>
                </Col>                
            </Row>
        </Container>
    )
}

export default DetailDataImplementProa;


